module.exports = __webpack_public_path__ + "img/Marketplace.4bce7057.svg";